"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Agent = require('./agent');
var _require = require('./agent'),
  createAgentUrl = _require.createAgentUrl,
  setupEventListeners = _require.setupEventListeners;

/**
 * @deprecated This module is deprecated and will be removed in a future version. Use the Agent module instead.
 * Interface to assistant SSE.
 *
 * @module assistant
 * @inner
 * @returns {object}
 */
var Assistant = /*#__PURE__*/function (_Agent) {
  function Assistant() {
    var _this;
    (0, _classCallCheck2["default"])(this, Assistant);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Assistant, [].concat(args));
    (0, _defineProperty2["default"])(_this, "EventTypes", Agent.EventTypes);
    return _this;
  }
  (0, _inherits2["default"])(Assistant, _Agent);
  return (0, _createClass2["default"])(Assistant, [{
    key: "getAssistantResultsStream",
    value:
    /**
     * Retrieve assistant results from EventStream
     *
     * @deprecated Use getAssistantResultsStream from the Agent module instead.
     * @function getAssistantResultsStream
     * @description Retrieve a stream of assistant results from Constructor.io API
     * @param {string} intent - Intent to use to perform an intent based recommendations
     * @param {object} [parameters] - Additional parameters to refine result set
     * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
     * @param {number} [parameters.numResultsPerPage] - The total number of results to return
     * @returns {ReadableStream} Returns a ReadableStream.
     * @example
     * const readableStream = constructorio.assistant.getAssistantResultsStream('I want to get shoes', {
     *     domain: "nike_sportswear",
     * });
     * const reader = readableStream.getReader();
     * const { value, done } = await reader.read();
     */
    function getAssistantResultsStream(query, parameters) {
      return this.getAgentResultsStream(query, parameters);
    }
  }]);
}(Agent);
module.exports = Assistant;
module.exports.createAssistantUrl = createAgentUrl;
module.exports.setupEventListeners = setupEventListeners;